/**
 * Storyblocks Schema Constants
 *
 * This file contains schema-dts compliant constants for Storyblocks organization data.
 * All constants are fully typed with schema-dts types and follow schema.org standards.
 */
import type { Organization, WebSite } from 'schema-dts';

import { PublisherReference } from './structuredData.types';

/**
 * Storyblocks Organization Schema
 */
export const STORYBLOCKS_ORG: Organization = {
  '@type': 'Organization',
  '@id': 'https://www.storyblocks.com/#organization',
  name: 'Storyblocks',
  url: 'https://www.storyblocks.com',
  logo: {
    '@type': 'ImageObject',
    url: 'https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/logos/unified/sb-logo.svg',
    contentUrl:
      'https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/logos/unified/sb-logo.svg',
    caption: 'Storyblocks Logo',
    description: 'Storyblocks Logo',
  },
  sameAs: [
    'https://www.linkedin.com/company/storyblocks',
    'https://www.youtube.com/channel/UCrxwwZTQOPCTUVlHsjNU7Fw',
    'https://twitter.com/StoryblocksCo',
    'https://www.instagram.com/StoryblocksCo/',
    'https://www.facebook.com/storyblocks/',
  ],
} as const;

/**
 * Publisher reference for use in other schemas (e.g., VideoObject, Article)
 */
export const STORYBLOCKS_PUBLISHER_REF: PublisherReference = {
  publisher: {
    ...STORYBLOCKS_ORG,
  },
};

/**
 * Storyblocks WebSite Schema
 */
export const STORYBLOCKS_WEBSITE: WebSite = {
  '@type': 'WebSite',
  '@id': 'https://www.storyblocks.com/#website',
  url: 'https://www.storyblocks.com',
  name: 'Storyblocks',
  ...STORYBLOCKS_PUBLISHER_REF,
} as const;
